import { Component, Input } from "@angular/core";
import { CDN_IMAGES } from '../../constants/param-constants';

@Component({
  selector: "upsell-wait",
  templateUrl: "upsell-wait.html",
  styleUrls: ['upsell-wait.scss'],
})

export class UpsellWaitComponent {

  @Input() iconWait: string = CDN_IMAGES.PALM_WAIT;
  @Input() iconText: string = 'WAIT!';
  @Input() isFull: boolean = false;
  @Input() title: string = '';
  @Input() description: string = '';

  constructor() {}
}
